import { useEffect, useState } from 'react'
import Tree, { ItemId } from 'tree-dnd'
import { Favorite } from 'api/clients/FavoriteClient'
import { mapFavoritesToTreeItems, useFavoritesTree } from './useFavoritesTree'
import { TreeRow } from '../../FilesTree/TreeRow/TreeRow'
import { toTree } from '../../FilesTree/treeUtils'

interface Props {
  className?: string
  favorites: Favorite[]
}

export const FavoritesTree = ({ favorites }: Props) => {
  const { tree: favoritesTree, setTree, removeItem, updateItem } = useFavoritesTree()
  const [selectedRows, setSelectedRows] = useState<ItemId>()

  useEffect(() => {
    const favoriteTreeItems = mapFavoritesToTreeItems(favorites)
    if (!favoriteTreeItems) return

    setTree(toTree(favoriteTreeItems))
  }, [favorites, setTree])

  return (
    favoritesTree && (
      <Tree
        tree={favoritesTree}
        renderItem={(props) => (
          <TreeRow
            {...props}
            isFavorite
            isLast={props.item.data.isLast}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            onRemoveItem={removeItem}
            updateItem={updateItem}
          />
        )}
        isDragEnabled={false}
        renderDropPlaceholder={(_) => <></>}
      />
    )
  )
}
